import { showDialog } from '../reducers/app';
import { setupEditMacroDialog } from '../reducers/edit_macro_dialog';
export function editMacro(id) {
    return (dispatch, getState) => {
        const { definitions } = getState();
        dispatch(setupEditMacroDialog(definitions.macros.entities[id]));
        dispatch(showDialog('macro-edit'));
    };
}
